import { mimeType31eog9gy5012s as mimeType } from '../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { renderImageThumbnail1u1tdw31b219h as renderImageThumbnail } from '../actuals/FileReference.ext.js.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_renderThumbnailOrNull__h4w5ck(_this__u8e3s4, maxSize, $completion) {
  var type = mimeType(_this__u8e3s4);
  var tmp;
  if (startsWith(type, 'image')) {
    var tmp_0;
    try {
      var tmp_1 = renderImageThumbnail(_this__u8e3s4, maxSize, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Exception()) {
        var e = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp = tmp_0;
  } else if (startsWith(type, 'video')) {
    tmp = null;
  } else {
    tmp = null;
  }
  return tmp;
}
function renderThumbnailOrNull(_this__u8e3s4, maxSize, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_renderThumbnailOrNull__h4w5ck.bind(VOID, _this__u8e3s4, maxSize), $completion);
}
//region block: exports
export {
  renderThumbnailOrNull as renderThumbnailOrNull3uya896byhc6g,
};
//endregion

//# sourceMappingURL=FileReference.ext.mjs.map
